import {IStyle} from '@wix/native-components-infra/dist/src/types/types'

export const generatedStyles: {[name: string]: string} = {}

export const GENERATED_STYLES_ID = 'events-generated-styles'

const config = [
  // {
  //   colorKey: 'evBackgroundColor',
  //   className: '.modalBackgroundColor',
  //   initial: 'color-1',
  //   opacity: 100,
  //   cssRule: value => `background-color: ${value}`,
  // },
  {
    colorKey: 'evBackgroundColor',
    selector: '.quantityPickerColumn .quantityPickerTooltipColor',
    initial: 'color-1',
    opacity: 100,
    cssRule: value => `color: ${value}`,
  },
  {
    colorKey: 'formLabelsColor',
    selector: '.eventsFormInput, .eventsFormCheckbox, .eventsFormRadio, .eventsFormSelect',
    initial: 'color-5',
    opacity: 0.2,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'formLabelsColor',
    selector: '.form-field__input, .formCheckbox, .formRadio, .formSelect',
    initial: 'color-5',
    opacity: 0.2,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'formLabelsColor',
    selector:
      '.form-field__input:focus:not(.form-field__input--error), .formSelect:focus, .formSelect--active, .formSelectOptions',
    initial: 'color-5',
    opacity: 0.8,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'formBackgroundColor',
    selector: '.eventsFormSelect.formSelectOptions',
    initial: 'color-1',
    opacity: 100,
    cssRule: value => `background-color: ${value}`,
  },
  {
    colorKey: 'formButtonBorderColor',
    selector:
      '.formWithHollowButton .formSelectOption:hover, .formWithHollowButton .formSelectOption--selected, .hollowActionColor',
    initial: 'color-8',
    opacity: 100,
    cssRule: value => `color: ${value}`,
  },
  {
    colorKey: 'formButtonBackgroundColor',
    selector:
      '.formWithFullButton .formSelectOption:hover, .formWithFullButton .formSelectOption--selected, .fullActionColor',
    initial: 'color-8',
    opacity: 100,
    cssRule: value => `color: ${value}`,
  },
  {
    colorKey: 'formSummaryColor',
    selector: '.eventsMembershipSelector.membershipOptionContainer:hover, .membershipOptionContainerActive',
    initial: 'color-5',
    opacity: 0.04,
    cssRule: value => `background-color: ${value}`,
  },
  {
    colorKey: 'formSummaryBoxBorderColor',
    selector:
      '.eventsFormSummaryBox.formSummaryBoxBorderColorActive, .eventsFormSummaryBox.formSummaryBoxBorderColorActive:focus, .eventsFormSummaryBox.formSummaryCouponCancel',
    initial: 'color-5',
    opacity: 100,
    cssRule: value => `border-color: ${value}`,
  },
  // {
  //   colorKey: 'formTitleColor',
  //   selector: '.ticket-form-divider',
  //   initial: 'color-5',
  //   opacity: 0.15,
  //   cssRule: value => `background-color: ${value}`,
  // },
  // {
  //   colorKey: 'formTitleColor',
  //   selector: '.ticket-form-submitted-info',
  //   initial: 'color-5',
  //   opacity: 0.8,
  //   cssRule: value => `color: ${value}`,
  // },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .evTicketDividerColor',
    initial: 'color-5',
    opacity: 0.15,
    cssRule: value => `border-color: ${value}`,
  },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .quantity-picker-border',
    initial: 'color-5',
    opacity: 0.15,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .quantity-picker-border-inner',
    initial: 'color-5',
    opacity: 0.15,
    cssRule: value => `border-color: ${value}`,
  },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .quantity-picker-border:hover',
    initial: 'color-5',
    opacity: 1,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .quantity-picker-disabled-sign',
    initial: 'color-5',
    opacity: 0.4,
    cssRule: value => `fill: ${value}`,
  },
  {
    colorKey: 'textColor',
    selector: '.ticketsPicker .quantity-picker-enabled-sign',
    initial: 'color-5',
    opacity: 1,
    cssRule: value => `fill: ${value}`,
  },
  {
    colorKey: 'formLabelsColor',
    selector: '.eventsFormInput:focus, .eventsFormSelect:focus, .eventsFormSelectActive, .eventsFormSelectOptions',
    initial: 'color-5',
    opacity: 0.8,
    cssRule: value => `border: 1px solid ${value}`,
  },
  {
    colorKey: 'formBackgroundColor',
    selector: '.eventsFormSelectOptions',
    initial: 'color-1',
    opacity: 1,
    cssRule: value => `background-color: ${value}`,
  },
  {
    colorKey: 'formButtonBorderColor',
    selector:
      '.eventsFormWithHollowButton .eventsFormSelectOption:hover, .eventsFormWithHollowButton .eventsFormSelectOptionSelected, .hollowActionColor',
    initial: 'color-8',
    opacity: 1,
    cssRule: value => `color: ${value}`,
  },
  {
    colorKey: 'formButtonBackgroundColor',
    selector:
      '.eventsFormWithFullButton .eventsFormSelectOption:hover, .eventsFormWithFullButton .eventsFormSelectOptionSelected, .fullActionColor',
    initial: 'color-8',
    opacity: 1,
    cssRule: value => `color: ${value}`,
  },
  {
    colorKey: 'formSummaryColor',
    selector: '.formSummaryCouponInput',
    initial: 'color-5',
    opacity: 0.2,
    cssRule: value => `border-color: ${value}`,
  },
  {
    colorKey: 'formSummaryColor',
    selector: '.formSummaryCouponInput',
    initial: 'color-5',
    opacity: 0.6,
    cssRule: value => `color: ${value}`,
  },
  // {
  //   colorKey: 'formLabelsColor',
  //   selector: '.mobileCouponInput',
  //   initial: 'color-5',
  //   opacity: 0.2,
  //   cssRule: value => `border-color: ${value}`,
  // },
  // {
  //   colorKey: 'formLabelsColor',
  //   selector: '.mobileReservationTimer',
  //   initial: 'color-5',
  //   opacity: 0.3,
  //   cssRule: value => `border-color: ${value}`,
  // },
  // {
  //   colorKey: 'formLabelsColor',
  //   selector: '.checkoutSummaryBackground',
  //   initial: 'color-5',
  //   opacity: 0.1,
  //   cssRule: value => `background-color: ${value}`,
  // },
  {
    selector: '.membershipOffersBorderColor',
    initial: 'color-5',
    opacity: 0.35,
    cssRule: value => `border-color: ${value}`,
  },
  {
    colorKey: 'formSummaryColor',
    selector: '.membershipOptionsContainer .formSummaryColorSecondary',
    initial: 'color-5',
    opacity: 0.4,
    cssRule: value => `color: ${value}`,
  },
]

const rgbaToRgba = (rgba: string, opacity: number) => {
  const parts = rgba.split(',')
  const alpha = opacity ?? parseFloat(parts[3])
  parts[3] = ` ${alpha})`
  return parts.join(',')
}

const rgbToRgba = (rgb: string, opacity: number) => {
  return rgb.replace(')', `, ${opacity})`).replace('rgb', 'rgba')
}

const hexToRgba = (hex: string, opacity: number) => {
  const r = parseInt(hex.substring(1, 3), 16)
  const g = parseInt(hex.substring(3, 5), 16)
  const b = parseInt(hex.substring(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const calculateColor = (color: string, opacity: number) => {
  if (color.includes('rgba')) {
    return rgbaToRgba(color, opacity)
  } else if (color.includes('rgb')) {
    return rgbToRgba(color, opacity)
  } else {
    return hexToRgba(color, opacity)
  }
}

export const namespaceClass = (className: string, compId: string) => `${className}_${compId}`

export const namespaceSelector = (selector: string, compId: string) =>
  selector.replace(/\.[a-zA-Z0-9_-]+/g, match => {
    const originalClass = match.substr(1)
    const namespacedClass = namespaceClass(originalClass, compId)
    generatedStyles[originalClass] = namespacedClass
    return `.${namespacedClass}`
  })

export const generateClasses = (style: IStyle, compId: string) => {
  const stylesElement = document.getElementById(GENERATED_STYLES_ID)
  if (!stylesElement) {
    console.error(`Error generating classes, ${GENERATED_STYLES_ID} tag does not exist`)
    return
  }

  stylesElement.innerHTML = ''

  config.map(item => {
    const color = style.styleParams.colors[item.colorKey]?.value || getColorByReference(style, item.initial)
    stylesElement.innerHTML += `
      ${namespaceSelector(item.selector, compId)} {
        ${item.cssRule(calculateColor(color, item.opacity))}
      }`
  })
}

const getColorByReference = (style: IStyle, reference: string) =>
  style.siteColors.find(color => color.reference === reference).value
